import '@babel/polyfill'
import 'nodelist-foreach-polyfill'
import Swiper, { Pagination } from 'swiper';

const selectors = {
  el: '.js-programmeCarousel',
  pagination: '.c-programme__pagination',
  bullet: '.swiper-pagination-bullet'
}

export default () => {
  const bulletwrap = document.querySelector('.js-pagination-bullets')
  var bulletTitle
  if(bulletwrap){
    bulletTitle = bulletwrap.dataset.dayTitle
  }
  window.programmeCarousel = new Swiper(selectors.el, {
    modules: [ Pagination ],
    effect: 'fade',
    slidesPerView: 1,
    pagination: {
      el: selectors.pagination,
      clickable: true,
      bulletClass: 'c-programme__bullet',
      bulletActiveClass: '-active',
      renderBullet: function (index, className) {
        return '<div class="' + className + '">' + bulletTitle + ' ' + (index + 1) + '</div>'
      }
    }
  })
}
